var map = {
	"./decidim/avatar-multiuser.png": 15442,
	"./decidim/brands/facebook.svg": 76292,
	"./decidim/brands/google.svg": 93469,
	"./decidim/brands/twitter-x.svg": 43502,
	"./decidim/cc-badge.png": 35660,
	"./decidim/decidim-logo.svg": 65120,
	"./decidim/default-avatar.svg": 65400,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 26564,
	"./decidim/icons.svg": 30931,
	"./decidim/pattern.png": 99972,
	"./decidim/placeholder-card-g.svg": 22577,
	"./decidim/placeholder-card-l.svg": 25722,
	"./decidim/placeholder.jpg": 23369,
	"./decidim/remixicon.symbol.svg": 50493,
	"./decidim/vendor/social-share-button/douban.svg": 92972,
	"./decidim/vendor/social-share-button/email.svg": 28457,
	"./decidim/vendor/social-share-button/facebook.svg": 27391,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 54241,
	"./decidim/vendor/social-share-button/hacker_news.svg": 17161,
	"./decidim/vendor/social-share-button/linkedin.svg": 18441,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 60426,
	"./decidim/vendor/social-share-button/pinterest.svg": 15887,
	"./decidim/vendor/social-share-button/reddit.svg": 81459,
	"./decidim/vendor/social-share-button/telegram.svg": 10982,
	"./decidim/vendor/social-share-button/tumblr.svg": 89829,
	"./decidim/vendor/social-share-button/twitter.svg": 2392,
	"./decidim/vendor/social-share-button/vkontakte.svg": 85718,
	"./decidim/vendor/social-share-button/wechat.svg": 68305,
	"./decidim/vendor/social-share-button/whatsapp.svg": 37753,
	"./decidim/vendor/social-share-button/x.svg": 59633,
	"./decidim/vendor/social-share-button/xing.svg": 43359
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61573;